import React from "react";

export function ReportsActions() {
	return (
		'Reports Actions'
	)
}
